<!--
 * @Descripttion:
 * @version:
 * @Author: tina.cai
 * @Date: 2021-04-16 11:51:52
 * @LastEditors: tina.cai
 * @LastEditTime: 2021-04-16 11:59:07
-->
<template>
  <div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>
import {decrypt, changeLanguage, GetRequestParam, isNotEmpty} from './assets/js/common';
import {createAppKit} from '@reown/appkit/vue';
import {networks, projectId, wagmiAdapter} from '@/config/wagmiConfig';

const appkit = createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  themeMode: 'light',
  features: {
    connectMethodsOrder: ['wallet'],
    analytics: true, // Optional - defaults to your Cloud configuration
  },
  metadata: {
    name: 'AppKit Vue Example',
    description: 'AppKit Vue Example',
    url: 'https://reown.com/appkit',
    icons: ['https://avatars.githubusercontent.com/u/179229932?s=200&v=4'],
    redirect: {
      native: 'metamask://',
      universal: 'https://metamask.app.link',
      linkMode: true,
    },
  },
  themeVariables: {
    '--w3m-accent': '#000000',
  },
});

export default {
  mounted() {
    var map = {};
    if (isNotEmpty(GetRequestParam().orderInfo)) {
      map = decrypt(GetRequestParam().orderInfo);
    }
    changeLanguage(map);
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
          Object.assign({},
              this.$store.state,
              JSON.parse(sessionStorage.getItem('store')),
          ));
      sessionStorage.removeItem('store');
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state));
    });

    this.$nextTick(() => {
      let realHeight = window.innerWidth > window.innerHeight ? window.innerWidth :
          window.innerHeight;
      this.setMetaHeight(realHeight);
    });
  },

  methods: {
    // 设置meta高度 解决安卓浏览器软键盘弹起，占用窗口的面积问题
    setMetaHeight(height) {
      document.head.querySelector('meta[name=\'viewport\']').setAttribute('id', 'viewportMeta');
      let metaEl = document.querySelector('#viewportMeta');
      let content = 'height=' + height + ',width=device-width,initial-scale=1.0,user-scalable=no';
      metaEl.setAttribute('name', 'viewport');
      metaEl.setAttribute('content', content);
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss">
@use './assets/css/reset.scss'  as *;
</style>
